import React from "react";
import Box from "@mui/material/Box";
import DataTools from "../../DataTools/DataTools";
import { Link } from "react-router-dom";
import "../../SidebarMenu/categoryStyle.css";

export default function QualitySandControlScreen() {
  const displayedIds = [9, 10, 11];
  const displayedTools = DataTools.filter((tool) =>
    displayedIds.includes(tool.id)
  );

  return (
    <Box className="main-box">
      {displayedTools.map((tool, index) => (
        <Box key={index} >
        <Link
              to={`/tool/details/${tool.id}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
          <Box className="box">
            <img src={tool.image} alt={`Tool ${tool.id}`}    className="image" />
          </Box>
          <Box className="title">
            <p>{tool.title}</p>
          </Box>
          </Link>
        </Box>
      ))}
    </Box>
  );
}
